import { Button } from "@/components/ui/button.tsx"
import { isSuperCoffeeUser } from "@/utils"
import { Search } from "lucide-react"

interface GoogleDriveSearchProps {
  orgId?: string
  source?: string
  invoiceNumber?: string
}

export function GoogleDriveSearch({ orgId, source, invoiceNumber }: GoogleDriveSearchProps) {
  if (
    !orgId || 
    !source || 
    !invoiceNumber || 
    !isSuperCoffeeUser(orgId) || 
    ["kehe", "unfi"].includes(source.toLowerCase())
  ) {
    return null
  }

  return (
    <Button
      variant="outline"
      // @ts-ignore
      size="sm"
      asChild
    >
      <a
      // 136ffeEOWrOHjb9gwdIEUrBF2wd1zPQ5m ==> Customer Billbacks and Credits
      // 11iZs0ixN3vdHbUEWaPolSv3auA1Za7aZ ==> Customer Payments and Deductions. https://drive.google.com/drive/search?q=asdf%20parent:11iZs0ixN3vdHbUEWaPolSv3auA1Za7aZ
        href={`https://drive.google.com/drive/search?q=${encodeURIComponent(invoiceNumber)}&parent:136ffeEOWrOHjb9gwdIEUrBF2wd1zPQ5m`}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-2"
      >
        <Search className="h-4 w-4" />
        Search Google Drive for Backup
      </a>
    </Button>
  )
} 